import { render, staticRenderFns } from "./UnidadeMedidaAreaManage.vue?vue&type=template&id=c4d59fb6&scoped=true"
import script from "./UnidadeMedidaAreaManage.vue?vue&type=script&lang=js"
export * from "./UnidadeMedidaAreaManage.vue?vue&type=script&lang=js"
import style0 from "./UnidadeMedidaAreaManage.vue?vue&type=style&index=0&id=c4d59fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d59fb6",
  null
  
)

export default component.exports